import { render, staticRenderFns } from "./BalanceView.vue?vue&type=template&id=9ea3e64a&scoped=true"
import script from "./BalanceView.vue?vue&type=script&lang=js"
export * from "./BalanceView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea3e64a",
  null
  
)

export default component.exports